import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { IconButtonComponent } from './icon-button.component';
import { PermissionButtonDirective } from './permission-button.directive';

@NgModule({
    declarations: [IconButtonComponent],
    exports: [IconButtonComponent, PermissionButtonDirective],
    imports: [CommonModule, NgbModule, PermissionButtonDirective],
})
export class IconButtonModule {}
